<template>
  <a-social-sharing
    hashtags="investingLive"
    twitter-user="investinglive"
    network="facebook"
    class="social-icon-border"
    :url="sharingUrl"
    :title="title"
    :description="description"
    :quote="title"
    :open-in-iframe="openInIframe"
  >
    <a-icon
      v-bind="$attrs"
      is-button
      tabindex="-1"
      :width="16"
      :height="16"
      :icon="$attrs.icon || ICON.FACEBOOK_PURPLE"
    />
  </a-social-sharing>
</template>

<script>
import socialSharing from '../socialSharing'

export default {
  name: 'Facebook',
  mixins: [socialSharing]
}
</script>
